export default "__VITE_ASSET__D6v7w6pZ__"